export default {
  "首页": "Início",
  "订单": "Pedidos",
  "新闻": "Notícias",
  "个人中心": "Centro pessoal",
  "模拟账户": "Conta demo",
  "可用资产": "Ativos disponíveis",
  "入金": "Depósito",
  "出金": "Saque",
  "账单详情": "Detalhes da fatura",
  "重置模拟账户": "Redefinir conta demo",
  "钱包": "Carteira",
  "实名认证": "Autenticação real",
  "邀请好友": "Convidar amigos",
  "修改密码": "Alterar senha",
  "投诉邮箱": "E-mail de reclamações",
  "其它": "Outros",
  "公告": "Avisos",
  "语言": "Idioma",
  "是否退出登录": "Deseja sair da conta?",
  "复制": "Copiar",
  "复制成功": "Copia bem-sucedida",
  "发送验证码成功": "Código de verificação enviado com sucesso",
  "请输入密码": "Digite a senha",
  "请再次输入密码": "Digite a senha novamente",
  "复制邀请链接": "Copiar link de convite",
  "上传身份": "Faça upload do frente e verso do passaporte ou documento de identidade",
  "正面": "Frente",
  "上传正面": "Faça upload da frente do passaporte/documento de identidade",
  "反面": "Verso",
  "上传反面": "Faça upload do verso do passaporte/documento de identidade",
  "完善信息": "Preencha suas informações pessoais",
  "输入姓名": "Digite seu nome",
  "身份证号": "Número do passaporte/documento de identidade",
  "输入身份证号": "Digite seu número de passaporte/documento de identidade",
  "收款货币": "Moeda de recebimento",
  "银行名称": "Nome do banco",
  "收款人账户": "Conta do destinatário",
  "货币": "Moeda",
  "分店名称": "Nome da filial",
  "绑定银行卡": "Vincular cartão bancário",
  "银行地址": "Endereço do banco",
  "账号名称（假名）": "Nome da conta (nome fictício)",
  "绑定数字货币地址": "Vincular endereço de moeda digital",
  "余额": "Saldo",
  "联系客服": "Contatar suporte",
  "行情": "Mercado",
  "其他": "Outros",
  "设置": "Configurações",
  "收款人": "Destinatário",
  "添加": "Adicionar",
  "确认": "Confirmar",
  "取消": "Cancelar",
  "钱包地址": "Endereço da carteira",
  "请输入": "Digite",
  "退出登录": "Sair",
  "充值数量": "Quantidade de depósito",
  "提交": "Enviar",
  "银行卡": "Cartão bancário",
  "选择网络": "Escolher rede",
  "数字货币": "Criptomoeda",
  "上传验证": "Envio de verificação",
  "提币地址": "Endereço de saque",
  "数量(USD)": "Quantidade (USD)",
  "备注": "Observação",
  "手续费": "Taxa",
  "预计到账数量": "Quantidade estimada para recebimento",
  "暂无数据": "Sem dados",
  "入金记录": "Registro de depósito",
  "提币记录": "Registro de saque",
  "验证码": "Código de verificação",
  "邀请码": "Código de convite",
  "提示": "Dica",
  "请输入验证码": "Digite o código de verificação",
  "姓名": "Nome",
  "邮箱登录": "Login por e-mail",
  "邮箱": "E-mail",
  "密码": "Senha",
  "新用户": "Novo usuário",
  "立即加入": "Junte-se agora",
  "忘记密码": "Esqueceu a senha",
  "登录": "Entrar",
  "无需开户,立即创建模拟账号进行交易!": "Sem necessidade de abrir uma conta, crie uma conta demo agora para começar a negociar!",
  "电话": "Telefone",
  "再次输入密码": "Digite a senha novamente",
  "职业": "Profissão",
  "年收入": "Renda anual",
  "注册": "Registrar",
  "邮箱注册": "Registro por e-mail",
  "发送": "Enviar",
  "重置密码": "Redefinir senha",
  "是否重置": "Deseja redefinir?",
  "已重置": "Redefinido",
  "名称": "Nome",
  "注册成功": "Registro bem-sucedido",
  "加载中": "Carregando",
  "您还未登录，请先登录": "Você ainda não está logado, faça login primeiro",
  "退出成功": "Logout bem-sucedido",
  "市价": "Preço de mercado",
  "挂单": "Ordem pendente",
  "倍数": "Multiplicador",
  "止盈": "Take Profit",
  "止损": "Stop Loss",
  "买入数量": "Quantidade de compra",
  "每手": "Por contrato",
  "预估手续费": "Taxa estimada",
  "预估保证金": "Margem estimada",
  "买入": "Comprar",
  "卖出": "Vender",
  "您的订单已确认": "Seu pedido foi confirmado",
  "订单页面": "Página de pedidos",
  "盈亏": "Lucro/Prejuízo",
  "当前保证金": "Margem atual",
  "订单详情": "Detalhes do pedido",
  "保证金": "Margem",
  "平仓": "Fechar posição",
  "修改": "Alterar",
  "手数": "Número de contratos",
  "暂无数据": "Sem dados",
  "历史": "Histórico",
  "价格": "Preço",
  "请输入价格": "Digite o preço",
  "手": "Contrato",
  "搜索结果": "Resultado da pesquisa",
  "搜索产品": "Pesquisar produto",
  "持仓": "Posições",
  "语言": "Idioma",
  "审核中": "Em revisão",
  "请上传证件照正/反面": "Por favor, envie fotos do frente/verso do documento",
  "上传成功": "Envio bem-sucedido",
  "上传失败": "Falha no envio",
  "提交成功": "Envio bem-sucedido",
  "删除": "Excluir",
  "删除成功": "Exclusão bem-sucedida",
  "提币": "Saque",
  "缺少参数或传值错误": "Parâmetro ausente ou erro no valor",
  "操作成功": "Operação bem-sucedida",
  "充值金额": "Montante de depósito",
  "类型": "Tipo",
  "状态": "Status",
  "时间": "Tempo",
  "单位": "Unidade",
  "最高价": "Preço máximo",
  "最低价": "Preço mínimo",
  "开盘价": "Preço de abertura",
  "请注册或登录真实账号": "Por favor, registre ou faça login na conta real",
  "没有更多了": "Sem mais dados",
  "提现金额": "Montante de saque",
  "审核通过": "Revisão aprovada",
  "审核不通过": "Revisão não aprovada",
  "重新提交": "Reenviar",
  "止盈价": "Preço de Take Profit",
  "止损价": "Preço de Stop Loss",
  "总盈亏": "Lucro/Prejuízo total",
  "撤单": "Cancelar pedido",
  "请先进行实名认证": "Por favor, realize a autenticação real primeiro",
  "产品列表": "Lista de produtos",
  "下单": "Fazer pedido",
  "可用资金": "Fundos disponíveis",
  "欢迎登录": "Bem-vindo(a) de volta",
  "可用": "Disponível",
  "冻结": "Congelado",
  "财务记录": "Registro financeiro",
  "交易对": "Par de negociação",
  "开仓时间": "Hora de abertura",
  "收益": "Lucro",
  "操作": "Ação",
  "下单价": "Preço de pedido",
  "当前价": "Preço atual",
  "订单号": "Número do pedido",
  "请选择": "Por favor escolha",
  "卖出(做空)止损价不能低于开仓价": "O preço de stop loss de venda (venda a descoberto) não pode ser inferior ao preço de abertura",
  "卖出(做多)止盈价不能高于开仓价": "O preço de take profit de venda (longa) não pode ser superior ao preço de abertura",
  "买入(做多)止损价不能高于开仓价": "O preço de stop loss de compra (longa) não pode ser superior ao preço de abertura",
  "买入(做多)止盈价不能低于开仓价": "O preço de take profit de compra (longa) não pode ser inferior ao preço de abertura",
  "买入(做多)止盈价不能低于开仓价和现价": "O preço de take profit de compra (longa) não pode ser inferior ao preço de abertura e ao preço atual",
  "买入(做多)止损价不能高于开仓价和现价": "O preço de stop loss de compra (longa) não pode ser superior ao preço de abertura e ao preço atual",
  "卖出(做空)止损价不能低于开仓价和现价": "O preço de stop loss de venda (venda a descoberto) não pode ser inferior ao preço de abertura e ao preço atual",
  "卖出(做多)止盈价不能高于开仓价和现价": "O preço de take profit de venda (longa) não pode ser superior ao preço de abertura e ao preço atual",

  "提现手续费": "Taxa de levantamento",
  "提现退回": "Reembolso de retirada",
  "系统加款": "Complementos do sistema",
  "系统减款": "Redução do sistema",

  "交易周期": "Ciclo de transação",
  "秒": "Segundo",
  "交易额": "Valor da transação",
  "买涨": "Comprar esperando um aumento",
  "买跌": "Comprar esperando uma queda",
  "秒数": "Número de segundos",
  "交易类型": "Tipo de transação",
  "看涨": "Ser otimista em relação ao aumento",
  "看跌": "Ser pessimista em relação ao aumento / Esperar uma queda",
  "剩余时间": "Tempo restante",
  "买入价": "Preço de compra",
  "结算价": "Preço de liquidação",
  "交易额": "Valor da transação",
  "下单时间": "Hora de placing o pedido",
  "结算时间": "Hora de liquidação",
  "该币种暂无交易": "Atualmente não existem transações para esta moeda",

  "总资产": "Ativos totais",
  "币种": "Moeda",
  "资产折合": "Conversão de ativos",
  "冻结金额": "Montante congelado",
  "可用金额": "Montante disponível",
  "公司资产": "Ativos da empresa",
  "请输入旧密码": "Por favor, insira a senha antiga",
  "请输入新密码": "Por favor, insira a nova senha",
  "请再次输入新密码": "Por favor, insira novamente a nova senha",
  "白皮书": "Livro Branco",
  "注册证书": "Certificado de registro",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "O direito de interpretação definitiva das informações acima mencionadas é da autoridade oficial.",
  "上一页": "Página anterior",
  "下一页": "Próxima página",
  "关闭": "Fechar",
  "闪电兑换": "Troca relâmpago",
  "全部": "Tudo",
  "可用余额": "Saldo disponível",
  "到": "Até",
  "请输入数量": "Por favor, insira a quantidade",
  "币种选择": "Seleção de moeda",
  "从": "De",
  "兑换": "Trocar",
  "兑换成功！": "A troca foi bem-sucedida!",
  "支付": "Pagar",
  "全部兑换成功": "Todas as trocas foram bem-sucedidas",
  "获取": "Obter",
  "数量": "quantidade",
  "拒绝原因": "Rejeitar Razão",
  "交易密码": "Senha de transação",
  "设置交易密码": "Configurar a senha de transação",
  "重置交易密码": "Redefinir a senha de transação",
  "确定": "Confirmar",
  "是否购买？": "Comprar?",
  "外汇": "Câmbio",
  "期权": "Opções",
  "(用户中心)": "(Centro do Usuário)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Sua transação está sendo processada, aguarde pacientemente a conclusão da transação antes de realizar outras operações!",
  "继续下单": "Continuar pedido",
  "交易方向": "Direção de negociação",
  "实现盈利": "Realizar lucro",
  "最新价格": "Preço mais recente",
  "结算完成": "Liquidação concluída",
  "下单余额不足": "Saldo insuficiente para fazer o pedido",
  "输入交易额度": "Digite o valor da transação",
  "选择交易周期": "Escolha o período de negociação",
  "审核拒绝": "Revisão recusada",
  "请输入正确的数量!": "Por favor, insira a quantidade correta!",
  "上传身份": "Carregar identidade",
  "上传正面": "Carregar frente",
  "上传反面": "Carregar verso",
  "完善信息": "Complete as informações",
  "输入姓名": "Digite o nome",
  "输入身份证号": "Digite o número do documento de identidade",
  "身份证号": "Número do documento de identidade",
  "请上传证件照正/反面": "Por favor, carregue a frente/verso do documento",
  "最小提现金额10USDT": "O valor mínimo para saque é 10 USDT",
  "证件号码": "Número de identificação",
  "输入证件号码": "Digite o número de identificação",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Por favor, envie seu documento de identidade, carteira de motorista ou passaporte para verificação de identidade!"


}
